module.exports = __webpack_public_path__ + "img/jc-steele-placehold.1c9733c2.jpg";